(function ($) {

    var LanguageSwitcher = function(rootElement) {
      this.$root = $(rootElement)
      this.$labelRoot = this.$root.find('.languages-label-wrapper')
      this.$selectRoot = this.$root.find('.languages-select-wrapper')

      this._labels = this.$selectRoot.find('select option')
        .map(function(index, element) {
            return {
              "key": $(element).val(),
              "value": $(element).text()
            }
        })
        .toArray()

      this._key = langify.helper.getSelectedLanguage();
      this._value = this.$selectRoot.find('select option[value="' + this._key + '"]').text()
      this._isOpen = false

      this.initLabels()


    } 

    LanguageSwitcher.prototype = {
      clickLabel: function(event) {
        console.log('clickLabel')
        if (!this._isOpen) {
          this._open()
        } else {
          this._updateValue(event)
          this._close()
        }
      },

      clickOutside: function(event) {
        if (this._isOpen) {
          this._close()
        }
      },

      initLabels: function() {

        var $labelRoot = this.$labelRoot

        $labelRoot.empty()
        $labelRoot.append("<div data-key=" + this._key +" class=\"label currentValue\">" + this._value + "</div>")

        this._labels.map(function(label, index) {
            $labelRoot.append("<div data-key=" + label.key +" class=\"label\">" + label.value + "</div>")
        })

      },

      _open: function() {
        this.$root.addClass('opened')
        this._isOpen = true
      },

      _close: function() {
        this.$root.removeClass('opened')
        this._isOpen = false
      },

      _updateValue: function(event) {
        var selectedValue = $(event.currentTarget).text()
        var selectedKey = $(event.currentTarget).data('key')

        // global 関数
        console.log({selectedKey})
        console.log({selectedValue})
        setLanguageCodeByLanguageId(selectedKey);

        if (this._key !== selectedKey) {
         this._key = selectedKey
         this._value = selectedValue
         this.$labelRoot.find('.currentValue').text(selectedValue)
         this.$selectRoot.find('select').val(selectedKey).change()
        }
      }
    }

    $(function() {
        var ls = new LanguageSwitcher('.languages-switcher')

        $('.languages-switcher .label').on('click', function(event) {
            event.preventDefault
            ls.clickLabel(event)
        })

        $('#ly-languages-switcher').on('change', function(event) {
            event.preventDefault
            ls.initLabels(event)
        })
        $(document).on('click touchend', function(event) {
            if (!$(event.target).closest('.languages-switcher').length) {
              ls.clickOutside(event)
            }
        })
    })

    $(function() {
        var hasCookieConsent = document.cookie.split(';').some(function(value) {
            var tmp = value.split('=')
            return tmp[0].indexOf('cookieconsent_status') !== -1
        })

        console.log(hasCookieConsent)

        if (hasCookieConsent) {
          return
        }

        var clickCookieBanner = function() {
          if ( window.innerHeight * 2 < $(document).scrollTop()) {
            console.log('click')
            var clickMe = document.getElementsByClassName('cc-btn')
            if (clickMe.length > 0) {
              var event = document.createEvent( "MouseEvents" )
              event.initEvent("click", true, true)
              clickMe[0].dispatchEvent(event)
              $(window).off('scroll.clickcookie load.clickcookie resize.clickcookie')
            }
          }
        }

        $(window).on('scroll.clickcookie load.clickcookie resize.clickcookie', clickCookieBanner)


        var observer = new MutationObserver(function (records, observer) {
            records.forEach(function(record) {
                console.log(records)
                if(record.type === 'childList' && record.addedNodes.length > 0) {
                  if (record.addedNodes[0].classList.contains('cc-window')) {

                    console.log('step2')
                    var count = 0;

                    var timer = setInterval(function() {
                        var cookieBanner = $('.cc-window')

                        if (!cookieBanner.hasClass('cc-invisible')) {
                          $('body').addClass('cookie-dialog-loaded')

                          $('.cc-compliance').on('click touchend', function(event) {
                              $('body').removeClass('cookie-dialog-loaded')

                              var marginBottom = 0;
                              $('.languages-switcher').css('margin-bottom', marginBottom);

                          });

                          $(window).on('scroll.lymargin load.lymargin resize.lymargin',function() {
                              if ($('body').hasClass('cookie-dialog-loaded')) {
                                var marginBottom = document.querySelector('.cc-window').clientHeight || 0;
                                $('.languages-switcher').css('margin-bottom', marginBottom);
                              }
                          })

                          var marginBottom = document.querySelector('.cc-window').clientHeight || 0;
                          $('.languages-switcher').css('margin-bottom', marginBottom);
                          clearInterval(timer);
                        }

                        if (count > 500) {
                          clearInterval(timer);
                        }
                        count++;
                    }, 20);

                    observer.disconnect();
                  }
                }
            });
        })

        var option = {
          childList: true
        }

        observer.observe(document.querySelector('body'), option)

    })
})(jQuery)
